import { IAccountModule, IUserModule } from 'app/models/interfaces';

export const PRESTART_CHECK_DASHBOARD_LABEL = 'Prestart Check Dashboard';

const PRESTART_MODULE_NAMES = [
  'prestart dashboard',
  'prestart check dashboard',
];

export function getModuleLabel(
  module: IAccountModule | IUserModule,
  prestartModuleId?: number
): string {
  const moduleName = String(module.ModuleName || '')
    .trim()
    .toLowerCase();
  const isPrestartModule =
    (prestartModuleId !== undefined &&
      module.ModuleId === prestartModuleId) ||
    PRESTART_MODULE_NAMES.includes(moduleName);

  return isPrestartModule
    ? PRESTART_CHECK_DASHBOARD_LABEL
    : module.ModuleName;
}
